import $ from 'jquery';
import Swiper from 'swiper';

export function initCarousel() {
  const galleryTopCarouselArray = $('[data-carousel-gallery-top]');
  galleryTopCarouselArray.each((i, element) => {
    let carouselId = $(element).attr('id');
    const galleryThumbSlides = document.querySelectorAll('[data-carousel-gallery-thumbnails] .swiper-slide');

    var galleryThumbs = new Swiper(`#gallery-thumbs--${carouselId}`, {
      spaceBetween: 24,
      slidesPerView: 4,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    });

    var galleryTop = new Swiper(`#${carouselId}`, {
      spaceBetween: 10,
      pagination: {
        el: `#swiper-pagination--${carouselId}`,
        type: 'fraction',
      },
      scrollbar: {
        el: `#swiper-scrollbar--${carouselId}`,
        hide: false,
        snapOnRelease: true,
        draggable: true
      },
      navigation: {
        nextEl: `#swiper-button-next--${carouselId}`,
        prevEl: `#swiper-button-prev--${carouselId}`,
      },
      thumbs: {
        swiper: galleryThumbs
      }
    });

    if (galleryTop && galleryTop.controller && galleryTop.controller.control){
      galleryTop.controller.control = galleryThumbs;
    }


    if (galleryThumbSlides && galleryThumbSlides.length) {
      galleryThumbSlides[0].classList.toggle('active', true);

      galleryTop.on('slideChange', function() {
        galleryThumbSlides.forEach(el => el.classList.toggle('active', false));
        galleryThumbSlides[this.activeIndex].classList.toggle('active', true);
      });
    }
  });

  $('[data-carousel]').each((i, element) => {

    let ogCarouselId = $(element).attr('id');
    let carouselId = ogCarouselId.replace('kg-blocks-carousel-full-width-', '');
    let enableObserverMode = $(element).attr('data-carousel-swiper-observer');

    new Swiper(`#${ogCarouselId} [data-swiper-container]`, {
      observer: !!enableObserverMode,
      observeParents: !!enableObserverMode,
      navigation: {
        nextEl: `#swiper-next-id-${carouselId}`,
        prevEl: `#swiper-prev-id-${carouselId}`,
      },
      slidesPerView: 'auto',
      centeredSlides: true,
      autoHeight: false,
      slideToClickedSlide: true,
      loop: false,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      spaceBetween: 30,
      zoom: {
        maxRatio: 5,
      },
      breakpoints: {
        992: {
          spaceBetween: 10,
        }
      },
      pagination: {
        el: `#${ogCarouselId} [data-swiper-progressbar]`,
        type: 'custom',
        renderCustom: function (swiper, current, total) {
          const fillEl = swiper.pagination.$el.parent().find('[data-swiper-progressbar-fill]');

          fillEl.css({
            width: 100 / total + '%',
            transform: 'translateX(' + (current - 1) * 100 + '%)'
          });

          return null;
        },
      },
    });
  });
}
